import Styles from './index.module.scss';

import type { ButtonSelectProps } from './types';

export const ButtonsSelect = ({ value, options, onChange }: ButtonSelectProps) => {
	return (
		<div className={Styles.container}>
			{options.map((option) => {
				return (
					<button
						key={option.value}
						type="button"
						className={`${value === option.value ? Styles.selected : ''} ${option.accentColor ? Styles.accentColor : ''}`}
						onClick={() => {
							onChange?.(option.value);
						}}
					>
						{!option.hideIcon && (
							<div
								className={Styles.pointer}
								style={{
									backgroundColor: option.accentColor,
									...(option.iconStyle ?? {}),
								}}
							/>
						)}
						{option.name}
					</button>
				);
			})}
		</div>
	);
};
